export function reformatText(e: any) {
    var x = e.target.value;
    if (x == "-") {
        return;
    }
    var navigate = "";
    if (x.startsWith('-')) {
        navigate = "-";
    }

    x = x.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
    var y = parseFloat(x);
    if (!x.endsWith('.') && y != 0 && !x.startsWith('-') && !x.endsWith('0')) {
        x = y.toString();
    }
    e.target.value = !isNaN(x) ? (navigate + x.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")) : '';
    return e
}
